// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";

// Material Kit 2 PRO React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

function StatsOne() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={60}
              suffix="%"
              title="Empresas"
              description=" buscam treinamentos adequados à executivos em resposta à multas devido à governança inadequada."
            />
          </Grid>
          <Grid item xs={12} md={4} display="flex">
            <DefaultCounterCard
              count={2667}
              prefix="~"
              title="Ataques"
              description="cibernéticos à organizações por semana, representando 53% crescimento YoY."
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={9}
              suffix="º"
              title="Ranking"
              description="Eleito o 9º melhor MBA no Reino Unido de acorcdo com a QS Global MBA rankings (2025)"
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default StatsOne;